import { useQuotationHeaderCondition } from './hooks/useQuotationHeaderCondition.hook';
import { hasNota } from './utils/quotation-header-conditions.util';
import type {
  ResolverParameters,
  ResolverResult,
} from '../types/resolvers.type';

export const useDevisAvecNota = (
  parameters: Readonly<ResolverParameters>,
): ResolverResult<boolean> => useQuotationHeaderCondition(parameters, hasNota);
